import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { NonLinearStepper } from '~/components/non-linear-stepper/NonLinearStepper';
import { useThemeStore } from '~/components/theme-controller/stores/useThemeStore';
import { AssetOverviewContent } from '~/widgets/company-to-theme-widget/tabs/assets-overview-tab/asset-overview-content/AssetOverviewContent';

import * as S from './CompetitorDetail.styles';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';

export const CompetitorDetail = ({
  entity,
  competitor,
}: {
  entity: Entity;
  competitor: Entity;
}) => {
  const { t } = useTranslation(['widget']);
  const { getThemedLogoUrl } = useThemeStore();

  return (
    <>
      <S.StepperWrapper>
        <NonLinearStepper
          activeIndex={1}
          iconSize={18}
          steps={[
            {
              logoUrl: getThemedLogoUrl(entity),
              hoverLabel: entity.name_short || entity.name,
              connectorLabel: t(
                'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.connectorLabel'
              ),
              highlightConnector: false,
              isSimple: false,
            },
            {
              logoUrl: getThemedLogoUrl(competitor),
              hoverLabel: competitor.name_short || competitor.name,
              highlightConnector: false,
            },
          ]}
        />
      </S.StepperWrapper>
      <AssetOverviewContent
        entity={competitor}
        source={POSTHOG_TRACKING_SOURCES.COMPETITORS_DRAWER}
      />
    </>
  );
};
